export const AVIS_PAGE = {
  key: "recolte-avis",
  title: "Récolte des BONS avis (process)",
  subtitle: "Récupérer des témoignages qui donnent envie de passer à l'action",
  sections: [
    {
      title: "🥂 Récupérer un avis pendant l’accompagnement",
      consignes: [
        "N'attends surtout pas la fin de ton accompagnement pour récolter des témoignages.",
        "À chaque fois que ta cliente partage une victoire, un déclic, une prise de conscience ou une évolution, profites-en pour creuser un peu plus. L'objectif est de l'amener à mettre des mots sur ce qui a changé pour elle → tu vas pouvoir t’en servir ensuite.",
      ],
      asides: [
        {
          title: "Le process à suivre",
          lines: [
            { h: "1. Repère un moment clé" },
            "Dès que ta cliente partage une victoire, un déclic ou un changement.",
            { h: "2. Creuse avec une question ouverte" },
            "Ne te contente pas d'un simple \"Bravo !\". Demande-lui par exemple :",
            { q: "Qu'est-ce qui a fait la différence selon toi ?" },
            { q: "Qu'est-ce qui est différent aujourd'hui par rapport à avant ?" },
            { q: "Tu peux m'en dire un peu plus ?" },
            { q: "Tu aurais un exemple concret ?" },
            { h: "3. Garde une trace" },
            "Avec son accord, conserve les captures d'écran, messages vocaux ou vidéos. Au fil de l'accompagnement, tu construiras une véritable bibliothèque de preuves, sans avoir à demander des témoignages à la fin.",
          ],
        },
      ],
    },
    {
      title: "🥂 Récupérer un avis à la fin de l’accompagnement",
      consignes: [
        "À la fin de l'accompagnement (ou dès qu'une cliente a déjà obtenu de vrais résultats), propose-lui un dernier appel de 15 à 20 minutes. Présente-le comme un moment pour répondre à ses dernières questions, faire un bilan ensemble… et, si elle est d'accord, recueillir son retour d'expérience.",
        "⚠️ Préviens-la toujours à l'avance que tu aimerais enregistrer une partie de l'appel afin de pouvoir utiliser son témoignage. L'objectif est qu'elle raconte son expérience avec ses propres mots, de la manière la plus naturelle possible.",
        "Pendant l'échange, évite de l'interrompre. Si une réponse est un peu courte, contente-toi de lui demander d'approfondir ou de préciser ce qu'elle veut dire. Plus son témoignage est spontané, plus il sera authentique et donnera envie à d'autres personnes de se reconnaître dans son parcours.",
      ],
      asides: [
        { title: "Mise dans le contexte", lines: [{ lead: "👉🏻 Est-ce que tu peux te présenter rapidement ?" }, { q: "Qui tu es ?" }, { q: "Qu’est-ce que tu fais exactement aujourd’hui ?" }] },
        {
          title: "Le avant",
          lines: [
            { lead: "👉🏻 Est-ce que tu peux m'expliquer précisément dans quelle situation tu étais avant de rejoindre mon accompagnement ?" },
            { q: "À quoi ressemblait ton quotidien à ce moment-là ?" },
            { q: "Comment tu te sentais ?" },
            { q: "Qu'est-ce qui était le plus difficile ou frustrant pour toi ?" },
            { q: "Quels étaient tes résultats à ce moment-là ? (clients, chiffre d'affaires, demandes, organisation, confiance en toi, etc.)" },
          ],
        },
        {
          title: "Les peurs avant de rejoindre l’accompagnement",
          lines: [
            { lead: "👉🏻 Qu’est-ce qui t’a fait hésiter avant de rejoindre l’accompagnement ?" },
            { q: "Est-ce que tu avais déjà investi dans un accompagnement auparavant ? Qu'est-ce que ça avait donné ?" },
            { q: "Est-ce que tu avais peur d'investir ?" },
            { q: "Est-ce que tu te demandais si ça allait vraiment fonctionner pour toi ?" },
            { q: "Qu'est-ce qui t'a finalement convaincue de passer à l'action ?" },
          ],
        },
        {
          title: "L’expérience pendant l’accompagnement",
          lines: [
            { lead: "👉🏻 Qu’est-ce que tu as ressenti pendant l’accompagnement ?" },
            { q: "Est-ce que tu t'es sentie accompagnée ?" },
            { q: "Qu'est-ce qui t'a le plus aidée pendant ces semaines ?" },
            { q: "Est-ce qu'il y a quelque chose qui te paraissait difficile ou inaccessible avant, et qui te semble aujourd'hui beaucoup plus simple ou naturel ?" },
          ],
        },
        {
          title: "Les résultats concrets",
          lines: [
            { lead: "👉🏻 Qu'est-ce que cet accompagnement a changé concrètement pour toi ? (Sois la plus précise possible.)" },
            "→ Compare ta situation avant / après.",
            { q: "Quels résultats as-tu obtenus ?" },
            { q: "Qu'est-ce qui a changé dans ton activité, ton quotidien ou ta façon de travailler ?" },
            { q: "Qu'est-ce qui a le plus évolué chez toi ?" },
            { q: "Selon toi, qu'est-ce qui se serait passé si tu étais restée seule ?" },
          ],
        },
        {
          title: "Objection",
          lines: [
            { lead: "👉🏻 Qu'est-ce que tu dirais à une personne qui hésite aujourd'hui à rejoindre mon accompagnement ?" },
            { q: "À celle qui pense qu'elle doit attendre le \"bon moment\" ?" },
            { q: "À celle qui a peur d'investir ?" },
            { q: "À celle qui pense qu'elle doit d'abord essayer encore seule ?" },
            { q: "À celle qui doute que ça puisse fonctionner pour elle ?" },
            { q: "Avec le recul, qu'est-ce que tu dirais à la version de toi qui hésitait avant de rejoindre l'accompagnement ?" },
          ],
        },
      ],
    },
    {
      title: "🥂 Faire une BONNE étude de cas (qui couvre les objections de ta cible)",
      consignes: [
        "Une bonne étude de cas ne consiste pas uniquement à montrer le résultat obtenu par ton client. L'objectif est de raconter son parcours en mettant en avant les doutes qu'il avait, les difficultés qu'il rencontrait, les déclics qu'il a eus et les résultats qu'il a obtenus. Plus ta cible se reconnaît dans son histoire, plus elle se projettera dans la sienne et se dira qu’elle aussi est capable d’y arriver : donc elle passera à l’action.",
      ],
      asides: [
        {
          title: "Le process",
          lines: [
            { h: "1. Le avant" },
            "Présente rapidement ton client et explique sa situation avant de travailler avec toi.",
            { q: "Qui est-il ?" },
            { q: "Quel problème rencontrait-il ?" },
            { q: "Comment se sentait-il ?" },
            { q: "Qu'est-ce qu'il avait déjà essayé ?" },
            { q: "Pourquoi ça ne fonctionnait pas ?" },
            { h: "2. La solution" },
            "Explique comment ton accompagnement lui a permis de débloquer la situation.",
            { q: "Qu'est-ce qui a réellement fait la différence ?" },
            { q: "Pourquoi cette approche a fonctionné ?" },
            { h: "3. Le après" },
            "Compare le avant / après.",
            { q: "Quels résultats concrets a-t-il obtenus ?" },
            { q: "Qu'est-ce qui a changé dans son quotidien ?" },
            { q: "Que dirait-il aujourd'hui à quelqu'un qui est dans la même situation ?" },
            { note: "N’hésite pas à ajouter des captures écran (prénom du client visible) ou bien le témoignage vidéo par la suite pour appuyer encore + ce que tu dis !" },
          ],
        },
      ],
    },
  ],
};
